<ul class="breadcrumbs">
  <li *ngFor="let i of breads" [routerLink]="i.link">{{i.name}}</li>
</ul>
